import { chains, } from "@bracket/chainography";
import type { ValidChainId, } from "./ValidChainId";

/** Token Name expressed either as its label or symbol */
export declare type TokenName<C extends ValidChainId = 1> =
	keyof typeof chains[C]["tokens"];

export const isTokenName = ( value: unknown, chainId: ValidChainId = 1 ): value is TokenName => {
	if(typeof value === "string") {
		return Object.keys(chains[chainId].tokens).includes(value);
	}
	return false;
}
